import React, { useState, useEffect } from 'react';
import { getUserUsage } from '../../services/usageService';
import { useAuth } from '../../contexts/AuthContext';
import styles from './UsageBadge.module.css';

const UsageBadge = () => {
  const [usage, setUsage] = useState(null);
  const [loading, setLoading] = useState(true);
  const { tokens } = useAuth();

  useEffect(() => {
    const fetchUsage = async () => {
      if (!tokens?.access_token) {
        setLoading(false);
        return;
      }

      try {
        const usageData = await getUserUsage(tokens.access_token);
        setUsage(usageData);
      } catch (error) {
        console.error('Failed to fetch usage:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchUsage();
  }, [tokens]);

  if (loading || !usage) {
    return null;
  }

  const percentage = (usage.remaining / usage.limit) * 100;
  const isLow = usage.remaining <= 1 && usage.remaining > 0;
  const isOut = usage.remaining === 0;

  // Select emoji based on status
  const getEmoji = () => {
    if (isOut) return '⚠️';
    if (isLow) return '⚡';
    return '✨';
  };

  return (
    <div className={`${styles['usage-badge']} ${isOut ? styles['usage-out'] : isLow ? styles['usage-low'] : ''}`}>
      <div className={styles['usage-icon-wrapper']}>
        <div className={styles['usage-icon']}>{getEmoji()}</div>
      </div>
      <div className={styles['usage-content']}>
        <div className={styles['usage-info']}>
          <div className={styles['usage-numbers']}>
            <span className={styles['remaining']}>{usage.remaining}</span>
            <span className={styles['separator']}>/</span>
            <span className={styles['total']}>{usage.limit}</span>
          </div>
        </div>
        <div className={styles['usage-label']}>
          {isOut ? '🚫 Limit tugadi' : '✨ Bepul tahlillar'}
        </div>
        <div className={styles['usage-bar-container']}>
          <div className={styles['usage-bar']}>
            <div
              className={styles['usage-progress']}
              style={{ width: `${percentage}%` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UsageBadge;
